import {
  Input,
  computed,
  inject,
  Component,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

import { Post } from 'src/app/core/models/core.models';
import { PostDetailsService } from 'src/app/core/services/post-details.service';

import { Observable } from 'rxjs';

@Component({
  selector: 'app-post-video',
  templateUrl: './post-video.component.html',
  styleUrls: ['./post-video.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PostVideoComponent {
  @Input() set postId(id: string) {
    this.shownPostId.set(id);
  }

  private readonly postDetails = inject(PostDetailsService);

  /** The post this tab is showing - the pane pushes it through the setter. */
  private readonly shownPostId = signal<string | null>(null);

  // `videos` is a `computed` over the pane's post rather than a field written from
  // a subscription.
  private readonly post = computed<Post>(() =>
    this.postDetails.postFor(this.shownPostId()),
  );

  postLoading$: Observable<boolean> = toObservable(
    computed(() => this.postDetails.isLoadingFor(this.shownPostId())),
  );

  readonly videos = computed(() => this.extractVideos(this.post()));

  private extractVideos(
    post: Post | undefined,
  ): { href: string; type: string }[] {
    if (!post?.attachments) return [];

    return post.attachments
      .filter(
        (attachment) =>
          attachment.type === 'mp4' || attachment.type === 'video',
      )
      .map((attachment) => ({
        href: attachment.href,
        type: attachment.href.includes('youtube')
          ? 'video/youtube'
          : 'video/mp4',
      }));
  }
}
